import type { QuickWritePrompt } from '@/types/quickWrite'

type Props = {
  prompt: QuickWritePrompt
  onSwap: () => void
}

export function PromptCard({ prompt, onSwap }: Props) {
  return (
    <div className="mb-4">
      <p className="font-display text-xl sm:text-2xl text-[var(--color-kids-text)] leading-snug">
        {prompt.text}
      </p>
      <button
        type="button"
        onClick={onSwap}
        className="mt-2 text-sm text-[var(--color-kids-text-muted)] hover:text-[var(--color-kids-primary)] underline-offset-2 hover:underline"
      >
        Try a different one
      </button>
    </div>
  )
}
